export const SKILL_DEFAULT_PRACTICE_LEVEL = 1;

export const skillSteps = ['Select Competencies', 'Reflect on them'];
